import React from "react";

import { push } from "connected-react-router";
import { toast } from "react-toastify";

import * as MarketplaceDemoAPI from "api/MarketplaceDemoAPI";
import * as BlueprintAPI from "api/BlueprintAPI";

import { getUserName } from "containers/Login/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as consultingProjectsReducer from "containers/ConsultingProjects/reducer";

import { isEnabled } from "utils/featureFlags";

const UPDATE_FIELD = "marketplaceDemo/UPDATE_FIELD";

const initialState = {
  blueprints: [],
  models: [],
  data: [],
  consulting: [],
  sausageModels: {},
  sausageConsulting: {},
  consultingBPLinks: {},
  publishingBP: true,
  name: "",
  price: 0,
  priceModifier: "",
  priceConditional: "",
  description: "",
  links: {}
};

function marketplaceReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getIsMarketplaceDemo() {
  return isEnabled("marketplace") && !isEnabled("marketplace-prod");
  // return isEnabled('marketplace');
}

export function getMarketplace(state) {
  return state.marketplaceDemo;
}

export function getBlueprints(state) {
  return getMarketplace(state).blueprints;
}

export function getModels(state) {
  return getMarketplace(state).models;
}

export function getConsulting(state) {
  return getMarketplace(state).consulting;
}

export function getData(state) {
  return getMarketplace(state).data;
}

export function getBPModels(state) {
  return getMarketplace(state).sausageModels;
}

export function getBPConsulting(state) {
  return getMarketplace(state).sausageConsulting;
}

export function getBPConsultingPost(state, id) {
  return getBPConsulting(state)[id];
}

export function getConsultingBPLinks(state) {
  return getMarketplace(state).consultingBPLinks;
}

export function getConsultantsLinkedToBP(state, bpID) {
  return getConsultingBPLinks(state)[parseInt(bpID)];
}

export function getPublishingBP(state) {
  return getMarketplace(state).publishingBP;
}

export function getNewBP(state) {
  return {
    price: getNewBPPrice(state),
    priceModifier: getNewBPPriceModifier(state),
    priceConditional: getNewBPPriceConditional(state),
    description: getNewBPDescription(state),
    rating: Math.random() * 3 + 2,
    reviews: Math.ceil(Math.random() * 45) + 5,
    links: getNewBPLinks(state)
  };
}

export function getNewBPPrice(state) {
  return getMarketplace(state).price;
}

export function getNewBPPriceModifier(state) {
  return getMarketplace(state).priceModifier;
}

export function getNewBPPriceConditional(state) {
  return getMarketplace(state).priceConditional;
}

export function getNewBPDescription(state) {
  return getMarketplace(state).description;
}

export function getNewBPLinks(state) {
  return getMarketplace(state).links;
}

export function getNewBPName(state) {
  return getMarketplace(state).name;
}

/* Actions */
export function updateBlueprints(blueprints) {
  return { type: UPDATE_FIELD, data: blueprints, key: "blueprints" };
}

export function updateModels(models) {
  return { type: UPDATE_FIELD, data: models, key: "models" };
}

export function updateData(data) {
  return { type: UPDATE_FIELD, data: data, key: "data" };
}

export function updateConsulting(consulting) {
  return { type: UPDATE_FIELD, data: consulting, key: "consulting" };
}

export function updateBPModels(modelObj) {
  return { type: UPDATE_FIELD, data: modelObj, key: "sausageModels" };
}

export function updateBPConsulting(consultingObj) {
  return { type: UPDATE_FIELD, data: consultingObj, key: "sausageConsulting" };
}

export function updateConsultingBPLinks(links) {
  return { type: UPDATE_FIELD, data: links, key: "consultingBPLinks" };
}

export function updatePublishingBP(isPublishing) {
  return { type: UPDATE_FIELD, data: isPublishing, key: "publishingBP" };
}

export function updateNewBPPrice(price) {
  return { type: UPDATE_FIELD, data: price, key: "price" };
}

export function updateNewBPPriceModifier(price) {
  return { type: UPDATE_FIELD, data: price, key: "priceModifier" };
}

export function updateNewBPPriceConditional(price) {
  return { type: UPDATE_FIELD, data: price, key: "priceConditional" };
}

export function updateNewBPDescription(description) {
  return { type: UPDATE_FIELD, data: description, key: "description" };
}

export function updateNewBPLinks(links) {
  return { type: UPDATE_FIELD, data: links, key: "links" };
}

export function updateNewBPName(name) {
  return { type: UPDATE_FIELD, data: name, key: "name" };
}

export function resetNewBlueprint() {
  return (dispatch, getState) => {
    const state = getState();
    getNewBPName(state) && dispatch(updateNewBPName(""));
    getNewBPPrice(state) && dispatch(updateNewBPPrice(0));
    getNewBPPriceModifier(state) && dispatch(updateNewBPPriceModifier(""));
    getNewBPPriceConditional(state) && dispatch(updateNewBPPriceConditional(""));
    getNewBPDescription(state) && dispatch(updateNewBPDescription(""));
    Object.keys(getNewBPLinks(state)).length && dispatch(updateNewBPLinks({}));
  };
}

/* Methods */
export function resetMarketplace() {
  return (dispatch, getState) => {
    dispatch(updateBlueprints([]));
    dispatch(updateModels([]));
    dispatch(updateData([]));
  };
}

export function fetchBlueprints() {
  return (dispatch, getState) => {
    const bpObj = blueprintReducer.getGlobal(getState());
    const blueprints = [];
    for (const key in bpObj) {
      if (key !== "new") {
        const bp = bpObj[key];
        if (
          bp &&
          bp.wizard &&
          bp.wizard.marketplace &&
          bp.wizard.marketplace.type === MarketplaceDemoAPI.TYPES.blueprints
        ) {
          blueprints.push(bp);
        }
      }
    }
    // Filter blueprints state for blueprints added to the market
    return dispatch(updateBlueprints(blueprints));
  };
}
export function fetchModels() {
  return (dispatch, getState) => {
    return MarketplaceDemoAPI.getModels().then((response) => {
      const bpModels = getBPModels(getState());
      response.forEach((model) => {
        if (bpModels[model.id]) {
          model.wizard.marketplace.purchased = true;
        }
        return model;
      });
      dispatch(updateModels(response));
    });
  };
}

export function fetchData() {
  return (dispatch, getState) => {
    return MarketplaceDemoAPI.getData().then((response) => {
      dispatch(updateData(response));
    });
  };
}

export function fetchConsulting() {
  return (dispatch, getState) => {
    const state = getState();
    const bpConsulting = getBPConsulting(state);
    const consulting = Object.values(bpConsulting).filter(Boolean);
    const bpLinks = {};
    consulting.forEach((consultant) => {
      if (
        consultant.wizard &&
        consultant.wizard.marketplace &&
        consultant.wizard.marketplace.consultingDetails &&
        consultant.wizard.marketplace.consultingDetails.links &&
        consultant.wizard.marketplace.consultingDetails.links.blueprints
      ) {
        consultant.wizard.marketplace.consultingDetails.links.blueprints.forEach((bp) => {
          bpLinks[bp.id] ? bpLinks[bp.id].push(consultant.id) : (bpLinks[bp.id] = [consultant.id]);
        });
      }
    });
    dispatch(updateConsultingBPLinks(bpLinks));
    return dispatch(updateConsulting(consulting));
  };
}

export function buyBlueprint(id) {
  return (dispatch, getState) => {
    const wizard = blueprintReducer.getBlueprint(getState(), parseInt(id)).wizard;
    wizard.marketplace.purchased = true;
    BlueprintAPI.updateBlueprint(id, wizard).then((response) => {
      dispatch(blueprintReducer.updateBlueprint(response.id, response));
      return dispatch(fetchBlueprints());
    });
  };
}

export function unbuyBlueprint(id) {
  return (dispatch, getState) => {
    const wizard = blueprintReducer.getBlueprint(getState(), parseInt(id)).wizard;
    wizard.marketplace.purchased = false;
    BlueprintAPI.updateBlueprint(id, wizard).then((response) => {
      dispatch(blueprintReducer.updateBlueprint(response.id, response));
      return dispatch(fetchBlueprints());
    });
  };
}

export function buyModel(id) {
  return (dispatch, getState) => {
    const models = getModels(getState()).map((model) => {
      if (model.id === id) {
        model.wizard.marketplace.purchased = true;
        MarketplaceDemoAPI.createModel(model.id, model.name, model.wizard).then((response) => {
          const bpModels = getBPModels(getState());
          bpModels[id] = response;
          return dispatch(updateBPModels(bpModels));
        });
      }
      return model;
    });
    dispatch(updateModels(models));
  };
}

export function unbuyModel(id) {
  return (dispatch, getState) => {
    const models = getModels(getState()).map((model) => {
      if (model.id === id) {
        model.wizard.marketplace.purchased = false;
        const bpModels = getBPModels(getState());
        BlueprintAPI.handleDelete(bpModels[id].id).then((response) => {
          delete bpModels[id];
          return dispatch(updateBPModels(bpModels));
        });
      }
      return model;
    });
    dispatch(updateModels(models));
  };
}

export function buyData(id) {
  return (dispatch, getState) => {
    const data = getData(getState()).map((data) => {
      if (data.id === id) {
        data.purchased = true;
      }
      return data;
    });
    dispatch(updateData(data));
  };
}

export function unbuyData(id) {
  return (dispatch, getState) => {
    const data = getData(getState()).map((data) => {
      if (data.id === id) {
        data.purchased = false;
      }
      return data;
    });
    dispatch(updateData(data));
  };
}

export function getDataInfo(bp) {
  return (dispatch, getState) => {
    const blueprint = blueprintReducer.getBlueprint(getState(), parseInt(bp.id));
    return blueprint;
  };
}

export function buyConsulting(id, details = {}) {
  return (dispatch, getState) => {
    const consulting = getBPConsulting(getState())[parseInt(id)];
    const wizard = consulting && consulting.wizard;
    wizard.marketplace.purchased = true;
    wizard.project = details;
    wizard.project.commissioner = getUserName(getState());
    wizard.project.status = consultingProjectsReducer.PROGRESS_STAGES.pendingAcceptance;
    wizard.project.awaiting = "author";
    if (wizard.project.price === undefined) {
      wizard.project.price = wizard.marketplace.consultingDetails.price;
    }
    if (wizard.project.priceModifier === undefined) {
      wizard.project.priceModifier = wizard.marketplace.consultingDetails.priceModifier;
    }
    if (wizard.project.priceConditional === undefined) {
      wizard.project.priceConditional = wizard.marketplace.consultingDetails.priceConditional;
    }
    return BlueprintAPI.updateBlueprint(id, wizard).then((response) => {
      const bpConsulting = getBPConsulting(getState());
      bpConsulting[response.id] = response;
      dispatch(updateBPConsulting(bpConsulting));
      return dispatch(fetchConsulting());
    });
  };
}

export function unbuyConsulting(id) {
  return (dispatch, getState) => {
    const consulting = getConsulting(getState()).map((consulting) => {
      if (consulting.id === id) {
        consulting.purchased = false;
      }
      return consulting;
    });
    dispatch(updateConsulting(consulting));
  };
}

export function addNewBPLink(type, items) {
  return (dispatch, getState) => {
    const links = getNewBPLinks(getState()) || {};
    links[type] = items;
    return dispatch(updateNewBPLinks(links));
  };
}

export function createConsulting(consulting) {
  consulting.rating = Math.random() * 3 + 2;
  consulting.reviews = Math.ceil(Math.random() * 45) + 5;
  return (dispatch, getState) => {
    return MarketplaceDemoAPI.createConsulting(consulting.name, consulting).then((response) => {
      const bpConsulting = getBPConsulting(getState());
      bpConsulting[response.id] = response;
      dispatch(updateBPConsulting(bpConsulting));
      dispatch(fetchConsulting());
    });
  };
}

export function deleteConsulting(id) {
  return (dispatch, getState) => {
    return BlueprintAPI.handleDelete(id).then((response) => {
      const bpConsulting = getBPConsulting(getState());
      delete bpConsulting[id];
      dispatch(updateBPConsulting(bpConsulting));
      dispatch(fetchConsulting());
    });
  };
}

export function getConsultingBPs(bps) {
  return (dispatch, getState) => {
    if (!bps) return [];
    const state = getState();
    const blueprints = bps.map((bp) => blueprintReducer.getBlueprint(state, parseInt(bp.id)));
    return blueprints;
  };
}

export function getConsultingData(data) {
  return (dispatch, getState) => {
    if (!data) return [];
    const state = getState();
    const retData = data.map((datum) => homeReducer.getDataset(state, parseInt(datum.id)));
    return retData;
  };
}

export function getConsultingPost(id) {
  return (dispatch, getState) => {
    const state = getState();
    return getBPConsultingPost(state, id);
  };
}

export function updateConsultingPost(id, consultingWizard) {
  return (dispatch, getState) => {
    const consulting = getBPConsulting(bps);
    let wizard = JSON.parse(JSON.stringify((consulting[id] && consulting[id].wizard) || {}));
    wizard = { ...wizard, ...consultingWizard };
    return BlueprintAPI.updateBlueprint(id, wizard).then((response) => {
      const bpConsulting = getBPConsulting(getState());
      bpConsulting[response.id] = response;
      dispatch(updateBPConsulting(bpConsulting));
      return dispatch(fetchConsulting());
    });
  };
}

export function getLinkedConsultants(bpID) {
  return (dispatch, getState) => {
    const state = getState();
    const links = getConsultantsLinkedToBP(state, bpID) || [];
    return links.map((id) => getBPConsultingPost(state, id));
  };
}

export default marketplaceReducer;
